import type {PS} from '@wix/document-services-types'
import type {MobileAlgoExtensionApi} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/mobileAlgo'
import type {EnvironmentExtensionAPI} from '@wix/document-manager-extensions'
import experiment from 'experiment'

const runResponsiveMobilForAllPages = async (ps: PS) => {
    const isEditor3 = (ps.extensionAPI as EnvironmentExtensionAPI).environment.isEditor3()
    const shouldRunMobileExp = experiment.isOpen('dm_shouldRunEditorThreeMobileAlgo')
    if (isEditor3 && shouldRunMobileExp) {
        const {mobileAlgo} = ps.extensionAPI as MobileAlgoExtensionApi
        await mobileAlgo.runForAllPages()
    }
}

export default runResponsiveMobilForAllPages
